import { useContext } from 'react';

import { PageInfoHeader } from '../../../PageInfoHeader/PageInfoHeader';

import { PMWorkbookTable } from './PMWorkbookTable/PMWorkbookTable';
import { PMWorkbookContext, withPMWorkbookContext } from './PMWorkbookContext';

import './PMWorkbook.scss';

const PMWorkbook = () => {
  const { tableDataLoaded } = useContext(PMWorkbookContext);
  return (
    <div className="eds-pm-workbook">
      <PageInfoHeader />
      {tableDataLoaded && <PMWorkbookTable />}
    </div>
  );
};

export default withPMWorkbookContext(PMWorkbook);
